/** @format */

import { defaultActions } from '../../core/actionsDefault';

export const cdrConstants = {
    LIST: 'cdr_list',
};

export class CdrActions extends defaultActions {}
